import React from 'react';
import { Route, Link } from 'react-router-dom';
import './App.scss';

function App() {
  return (
    <div className="App">

      <div className="body">

        <div className="title">All ABOUT MOTO SPORTS GEAR</div>

        <a href="https://smartstore.naver.com/motoplay" target="_blank">
          <div className="button">
            <div className="inside">
              <div className="icon"><img src="/icon_motoplay.svg" width="60px" /></div>
              <div className="text"><div className="center">모토플레이 온라인샵</div></div>
            </div>
          </div>
        </a>

        <a href="http://www.motoworks.co.kr/" target="_blank">
          <div className="button">
            <div className="inside">
              <div className="icon"><img src="/icon_motoworks.svg" width="60px" /></div>
              <div className="text"><div className="center">모토웍스 온라인샵</div></div>
            </div>
          </div>
        </a>

        <a href="https://www.youtube.com/channel/UCecYDX8Dr857puW5__qcJgg" target="_blank">
          <div className="button">
            <div className="inside">
              <div className="icon"><img src="/icon_youtube.svg" width="60px" /></div>
              <div className="text"><div className="center">#양만장#모토플레이 유튜브</div></div>
            </div>
          </div>
        </a>

        <a href="https://www.instagram.com/motoplay_yangmanjang" target="_blank">
          <div className="button">
            <div className="inside">
              <div className="icon"><img src="/icon_insta.svg" width="60px" /></div>
              <div className="text"><div className="center">모토플레이 인스타그램</div></div>
            </div>
          </div>
        </a>

        <a href="https://www.instagram.com/motoworks_korea" target="_blank">
          <div className="button">
            <div className="inside">
              <div className="icon"><img src="/icon_insta.svg" width="60px" /></div>
              <div className="text"><div className="center">모토웍스 인스타그램</div></div>
            </div>
          </div>
        </a>

      </div>

    </div>
  );
}

export default App;
